import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { QuillModule, QuillConfig } from "ngx-quill";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LandingPageComponent } from "./components/landing-page/landing-page.component";
import { LayoutComponent } from "./layout/layout.component";
import { DrawerComponent } from "./shared/drawer/drawer.component";
import { SharedModule } from "./shared/shared.module";
import { AuthInterceptor } from "./core/interceptors/auth.interceptor";
import { ErrorInterceptor } from "./core/interceptors/error.interceptor";
import { ContactUsComponent } from "./components/contact-us/contact-us.component";
import { MenuStateService } from "./core/services/menu-state.service";
import { ScrollService } from "./core/services/scroll.service";
import { PanVerifyResultComponent } from "./components/pan-verify-result/pan-verify-result.component";
import { NgoDiligenceComponent } from "./components/ngo-diligence/ngo-diligence.component";
import { FcraComplianceCardComponent } from "./components/ngo-diligence/fcra-compliance-card/fcra-compliance-card.component";
import { DarpanComplianceCardComponent } from "./components/ngo-diligence/darpan-compliance-card/darpan-compliance-card.component";
import { IncomeTaxComplianceCardComponent } from "./components/ngo-diligence/income-tax-compliance-card/income-tax-compliance-card.component";
import { GstComplianceCardComponent } from "./components/ngo-diligence/gst-compliance-card/gst-compliance-card.component";
import { Status206abCardComponent } from "./components/ngo-diligence/status206ab-card/status206ab-card.component";
import { BlacklistExposureCardComponent } from "./components/ngo-diligence/blacklist-exposure-card/blacklist-exposure-card.component";
import { RawDataTableComponent } from "./components/ngo-diligence/raw-data-table/raw-data-table.component";
import { OrganizationInfoCardComponent } from "./components/ngo-diligence/organization-info-card/organization-info-card.component";
import { MatDividerModule } from "@angular/material/divider";
import { ReportHistoryComponent } from "./components/report-history/report-history.component";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { UserProfileComponent } from "./components/user-profile/user-profile.component";

const quillConfig: QuillConfig = {
  modules: {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["clean"],
      ["link"],
    ],
  },
};

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    LandingPageComponent,
    DrawerComponent,
    ContactUsComponent,
    ReportHistoryComponent,
    PanVerifyResultComponent,
    FcraComplianceCardComponent,
    DarpanComplianceCardComponent,
    IncomeTaxComplianceCardComponent,
    GstComplianceCardComponent,
    Status206abCardComponent,
    BlacklistExposureCardComponent,
    RawDataTableComponent,
    OrganizationInfoCardComponent,
    UserProfileComponent,
    NgoDiligenceComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    DragDropModule,
    QuillModule.forRoot(quillConfig),
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    MenuStateService,
    ScrollService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
